var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:NanumGothicBold;src:url(" + escape(require("../font/NanumGothicBold.eot")) + ");src:local(\"\\263A\"),url(" + escape(require("../font/NanumGothicBold.woff")) + ") format(\"woff\"),url(" + escape(require("../font/NanumGothicBold.ttf")) + ") format(\"truetype\")}@font-face{font-family:NanumGothic;src:url(" + escape(require("../font/NanumGothic.eot")) + ");src:local(\"\\263A\"),url(" + escape(require("../font/NanumGothic.woff")) + ") format(\"woff\"),url(" + escape(require("../font/NanumGothic.ttf")) + ") format(\"truetype\")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/assets/css/webfont.css
// module id = 589
// module chunks = 0